export const MEASUREMENT_TYPES = {
  ARTICULATION: 1,
  DEFINITION_MATCHING: 2,
  FLUENCY: 3,
  SPEECH: 4, // TYPETOKENRATION TTR
  WCPM: 5,
  GENERAL: 6,
  READING: 7,
  NAMING: 8,
  SPELLING: 9,
  CUE: 10,
  RETRY: 11,
};

export const MEASUREMENT_MODELS = {
  ARTICULATION: "measurements_articulation",
  DEFINITIONMATCHING: "measurements_definitionmatching",
  FLUENCY: "measurements_fluency",
  TYPETOKENRATION: "measurements_typetokenratio",
  WCPM: "measurements_wcpm",
  GENERAL: "measurements_general",
  READING: "measurements_reading",
  NAMING: "measurements_naming",
  SPELLING: "measurements_spelling",
  CUE: "measurements_cue",
  RETRY: "measurements_retry",
};

export const MEASUREMENT_WCPM_TYPES = {
  READING: 1,
};

export const MEASUREMENT_WIDGETS_TYPES = {
  TITLE_WIDGET: "TitleWidget",
  IMAGE_WIDGET: "ImageWidget",
  CARD_WIDGET: "CardWidget",
  DECK_WIDGET: "DeckWidget",
  DICE_WIDGET: "DiceWidget",
  LETTER_ORDER_WIDGET: "LetterOrderWidget",
  CV_ORDER_WIDGET: "CVOrderWidget",
  TEXT_WIDGET: "TextWidget",
  SMART_TEXT_WIDGET: "SmartTextWidget",
  SPELLING_CHECK_WIDGET: "SpellingCheckWidget",
  SPELLING_DECK_WIDGET: "SpellingDeckWidget",
  SOUND_IDENTIFICATION_WIDGET: "SoundIdentificationWidget",
  MATCHIN_SORTING_WIDGET: "MatchinSorting",
  SYLLABIFICATION_WIDGET: "SyllabificationWidget",
  FILL_IN_WIDGET: "FillIn",

  CLONEAD_IMAGE: "CloneadImage",
};
